import { writable } from 'svelte/store';

export const textInfo = writable({name:'',
                                ship_type:'',
                                navigational_status:'',
                                speed:'',
                                heading:''
                            });